import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import NoticeOfIntentChangeRequestStep4Form from '../../../../components/forms/postSecondary/NoticeOfIntentChangeRequestStep4Form';
import Routes from '../../../../config/Routes';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import InstitutionDTO from '../../../../models/InstitutionDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NoticeOfIntentStep4PageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface NoticeOfIntentStep4PageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class NoticeOfIntentStep4Page extends React.Component<NoticeOfIntentStep4PageProps & RouteComponentProps<RouteObject>, NoticeOfIntentStep4PageState> {
  private readonly _newContactInformationNoticeOfIntentFormRef = React.createRef<NoticeOfIntentChangeRequestStep4Form>();

  constructor(props: NoticeOfIntentStep4PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }
  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');

    if (id == 'new') {
      this.setState({ isNew: true });
    }
    else if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  private goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_3, { id: this.state.changeRequestId }, {}))
  }

  private goToNextStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NOTICE_OF_INTENT_CHANGE_REQUEST_ENTRY_5, { id: this.state.changeRequestId }));
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={3}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="Consultant Meetings" >
            <NoticeOfIntentChangeRequestStep4Form
              ref={this._newContactInformationNoticeOfIntentFormRef}
              institutionId={this.state.changeRequest.institutionId}
              changeRequestId={this.state.changeRequest.id}
              isNew={this.state.isNew}
              onSubmit={this.goToNextStep}
              onPrevious={this.goToPreviousStep}
              loading={this.state.loading} />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(NoticeOfIntentStep4Page));